import { render, staticRenderFns } from "./idiomTips.vue?vue&type=template&id=7972a1d8&scoped=true&"
import script from "./idiomTips.vue?vue&type=script&lang=js&"
export * from "./idiomTips.vue?vue&type=script&lang=js&"
import style0 from "./idiomTips.vue?vue&type=style&index=0&id=7972a1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972a1d8",
  null
  
)

export default component.exports